import React from "react";
import classes from './LoadingApp.module.css'; 
import Logo from "../../../images/Logo-login-right.svg"; // Update path as needed

//I wanted it for when page lods and nothing is rendered yet, as of now it is not used, because the app is rendered immediately
const LoadingApp = () => {
  return (
    <div className={classes["app-loader-overlay"]}>
        <div className={classes['app-loader-logo-wrapper']}>
      <img src={Logo} alt="Loading..." className={classes["app-loader-logo"]} />
      </div>
    </div>
  );
};

export default LoadingApp;